import React from "react";
import PropTypes from "prop-types";
import PreloadedImage from "shared/components/PreloadedImage";
import UserThumb from "shared/components/UserThumb";

import UserWrapper from "apps/discovery/containers/user/UserWrapper";
import "./PhotoWithCaption.scss";

const CHAR_LIMIT = 45;

const PhotoWithCaption = (props) => {
	const { user, placeholder } = props;

	if (placeholder) {
		return (
			<div className="user-photoWithCaption isPlaceholder">
				<div className="user-photoWithCaption-image" />
				<div className="user-photoWithCaption-user-image" />
				<div className="user-photoWithCaption-bottom">
					<div className="user-photoWithCaption-bottom-content" />
				</div>
			</div>
		);
	}

	let caption = false;
	let url = "";

	if (user.photos[0]) {
		if (user.photos[0].info && user.photos[0].info.caption) {
			caption = user.photos[0].info.caption;
		}

		if (user.photos[0].full) {
			url = user.photos[0].full;
		}
	}

	return (
		<UserWrapper className="user-photoWithCaption" {...props}>
			<div className="user-photoWithCaption-image">
				<PreloadedImage url={url} />
			</div>
			<div className="user-photoWithCaption-user-image">
				<UserThumb
					{...user}
					size="100x100"
				/>
			</div>
			<div className="user-photoWithCaption-bottom">
				<div className="user-photoWithCaption-bottom-username">
					{user.userinfo.displayname}
				</div>
				{caption &&
					<div className="user-photoWithCaption-bottom-content">
						{caption.length <= CHAR_LIMIT &&
							<span>“{caption}”</span>
						}
						{caption.length > CHAR_LIMIT &&
							<span>“{caption.slice(0, CHAR_LIMIT)}…”</span>
						}
					</div>
				}
			</div>
		</UserWrapper>
	);
};

PhotoWithCaption.propTypes = {
	user: PropTypes.object,
	placeholder: PropTypes.bool,
};

export default PhotoWithCaption;



// WEBPACK FOOTER //
// ./src/apps/discovery/components/user/PhotoWithCaption.jsx